import { ApplicationTheme } from "src/components/shared-components/enum/enumMisc";
import { environmentCommonVariable } from "src/environments/environment-common";
import { EnvironmentSettings } from "src/environments/environment-settings";

const envDigitalPlaceDev: Partial<typeof environmentCommonVariable> = {
  production: false,
  theme: ApplicationTheme.DIGITAL_PLACE,
  httpDPAPIRoot: EnvironmentSettings.HTTP_DP_API_DEV_ROOT,
  httpServerRoot: EnvironmentSettings.HTTP_DP_API_DEV_SERVER,
  anaciPlatformAuth: EnvironmentSettings.ANACI_PLATFORM_AUTH,
  anaciPlatformBuilding: EnvironmentSettings.ANACI_PLATFORM_BUILDING,
  anaciPlatformProduct: EnvironmentSettings.ANACI_PLATFORM_PRODUCT,
  anaciPlatformUser: EnvironmentSettings.ANACI_PLATFORM_USER,
  anaciPlatformQuote: EnvironmentSettings.ANACI_PLATFORM_QUOTE,
  wsHostName: EnvironmentSettings.ANACI_WS_HOST_NAME_DEV,
  wsPort: EnvironmentSettings.ANACI_WS_PORT_DEV,
  cbid: EnvironmentSettings.COOKIEBOT_DEV_CBID,
  billAWSFolder: EnvironmentSettings.BILL_AWS_FOLDER_DEV,
  quoteAWSFolder: EnvironmentSettings.QUOTE_AWS_FOLDER_DEV,
  serverEndpoint: EnvironmentSettings.ANACI_SERVER_ENDPOINT_DEV,
  iconRepositoryEndpoint: EnvironmentSettings.API_ICON_REPOSITORY,
};

export const environment = {
  ...environmentCommonVariable,
  ...envDigitalPlaceDev,
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
